import { Add } from '@mui/icons-material'
import { Box, Button, Dialog, DialogActions, DialogContent, Tooltip, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AccountDtoPermission, AdopterDto } from '../../interactors/gen/backendClient'
import { useAccountsStore } from '../../store/AccountsStore'
import { useDialogOpened } from '../../utils/hooks/useDialogOpened'
import { PATHS } from '../PATHS'
import { theme } from '../theme'
import { ADOPTION_REQUEST_CHIP, AdoptionTypeCard } from './AdoptionTypeCard'

interface Props {
  adopter: AdopterDto
  sendEmailToAdopter: boolean
  setSendEmailToAdopter: (value: boolean) => void
}

export const AddAdoptionPopUp: React.FC<Props> = ({ adopter, sendEmailToAdopter }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const compactWidth = useMediaQuery(theme.breakpoints.down('lg'))
  const { isDialogOpen, openDialog, closeDialog } = useDialogOpened()
  const navigate = useNavigate()

  const accountsStore = useAccountsStore()
  const isReader = accountsStore.connectedAccount?.permission === AccountDtoPermission.Read
  const isNotAdmin = !accountsStore.isAdmin()
  const editorsCanCreateAdoptions = accountsStore.connectedCustomer?.editorsCanCreateAdoptions === true
  return (
    <>
      <Tooltip
        title={isNotAdmin && !editorsCanCreateAdoptions ? `L'administrateur ne vous a pas autorisé cet accès` : ``}
      >
        <span>
          <Button
            color="primary"
            variant="contained"
            sx={{
              textTransform: 'none',
              fontSize: isMobile ? '14px' : '16.5px',
              width: compactWidth ? '100%' : 'auto',
              maxWidth: compactWidth ? '100%' : 220,
              whiteSpace: compactWidth ? 'normal' : 'nowrap',
              textAlign: 'center',
              lineHeight: 1.15,
              borderRadius: 3.5,
              minHeight: compactWidth ? 40 : 44,
              px: compactWidth ? 2 : 2.5,
              alignSelf: compactWidth ? 'stretch' : 'auto',
            }}
            onClick={openDialog}
            disabled={isReader || (isNotAdmin && !editorsCanCreateAdoptions)}
          >
            {!compactWidth && <Add sx={{ mr: 1 }} />}
            Ajouter une adoption
          </Button>
        </span>
      </Tooltip>
      <Dialog
        open={isDialogOpen}
        onClose={closeDialog}
        PaperProps={{
          style: { borderRadius: 15, padding: isMobile ? 5 : 15 },
        }}
      >
        <DialogContent>
          <Box>
            <Typography variant="h4" component="h2" marginBottom={2} fontSize={isMobile ? 18 : 20}>
              Souhaitez-vous ajouter une adoption passée ou lancer une nouvelle procédure ?
            </Typography>
            <Typography variant="body2" component="p" marginBottom={isMobile ? 0 : 2} fontSize={15} fontStyle="italic">
              {`L'intérêt d'ajouter une adoption passée est de pouvoir conserver l'historique des adoptions de l'adoptant sur Petso.`}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 2 }}>
            {/* <ChooseToSendEmailToAdopter
              sendEmailToAdopter={sendEmailToAdopter}
              setSendEmailToAdopter={setSendEmailToAdopter}
              text="general"
              vertical
            /> */}

            <Box
              sx={{
                display: 'grid',
                // The adoption request carries the chip and three lines of explanation, the past
                // adoption one line, so the space follows the content rather than being halved.
                gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr',
                width: '100%',
                gap: 1.5,
              }}
            >
              <AdoptionTypeCard
                title="Une demande d'adoption"
                chip={ADOPTION_REQUEST_CHIP}
                description={
                  <>
                    Le statut de l&apos;animal choisi passera en cours d&apos;adoption.
                    <Box component="span" sx={{ display: 'block', mt: 0.35 }}>
                      → Un lien de paiement du montant de l&apos;adoption sera également transmis à l&apos;adoptant pour
                      règlement.
                    </Box>
                  </>
                }
                onClick={() => {
                  navigate(`${PATHS.suiviAdoptant.absolute}/${adopter.id}?tab=profil&newAdoption=true`)
                  closeDialog()
                }}
              />
              <AdoptionTypeCard
                title="Une adoption passée"
                description="Enregistre l'historique d'une adoption déjà réalisée, sans paiement en ligne."
                onClick={() =>
                  navigate(
                    `${PATHS.assignerAnimal.absolute}?adopterId=${
                      adopter.id
                    }&type=pastAdoption&sendEmailToAdopter=${sendEmailToAdopter.toString()}`
                  )
                }
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  )
}
